import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { MlTrainingJob, MlTrainingJobCreate, MlTrainingJobFilter } from '../data/mlTrainingJob';

export function createMlTrainingJobService(client: AxiosInstance) {
  return createCrudService<MlTrainingJob, MlTrainingJobCreate, MlTrainingJobFilter>(
    client,
    '/ai/MlTrainingJob',
    'id',
  );
}

export type MlTrainingJobService = CrudService<MlTrainingJob, MlTrainingJobCreate, MlTrainingJobFilter>;
